import React from "react";
import {
  ArrowBack,
  ArrowLeft,
  Bell,
  Briefcase,
  ChevronDown,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  Clipboard,
  Cross,
  DragVerticalFill,
  Edit,
  Enlarge,
  Envelope,
  EyeOpen,
  Folder,
  FullScreen,
  Gear,
  Grid,
  Home,
  Key,
  LockOn,
  MoreVerticalFill,
  Network,
  PeopleGroup,
  PeopleMultiple,
  Person,
  Phone,
  Plus,
  Receipt,
  Reduce,
  ArrowCycle,
  Minus,
  Search,
  Shield,
  SignOut,
  ThreeLineHorizontal,
  TrashCan,
  TriangleAlert,
  CloudUpload,
  Download,
  File,
  Calendar,
  Clock,
  Check,
} from "akar-icons";

const SIZE = { small: 18, medium: 22, large: 30, inherit: 22 };

const akarize = (Component, defaults = {}) =>
  React.forwardRef((props, ref) => {
    const {
      fontSize,
      sx,
      style,
      size,
      strokeWidth,
      color,
      className,
      ...rest
    } = props;

    const finalSize = size ?? SIZE[fontSize] ?? defaults.size ?? 22;
    const finalStroke = strokeWidth ?? defaults.strokeWidth ?? 1.6;
    const mergedStyle = { ...(style || {}), ...(sx || {}) };
    const finalColor = color ?? mergedStyle.color;
    const cleanStyle = { ...mergedStyle };
    delete cleanStyle.color;
    delete cleanStyle.fontSize;

    return (
      <span
        ref={ref}
        className={className}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: finalColor || "inherit",
          lineHeight: 0,
          flexShrink: 0,
          ...cleanStyle,
        }}
        {...rest}
      >
        <Component size={finalSize} strokeWidth={finalStroke} color="currentColor" />
      </span>
    );
  });

export const AddIcon = akarize(Plus);
export const AddRoundedIcon = akarize(Plus);
export const VisibilityOutlinedIcon = akarize(EyeOpen);
export const MoreVertIcon = akarize(MoreVerticalFill);
export const DeleteOutlineIcon = akarize(TrashCan);
export const DeleteOutlineOutlinedIcon = akarize(TrashCan);
export const EditIcon = akarize(Edit);
export const EditOutlinedIcon = akarize(Edit);
export const HomeOutlinedIcon = akarize(Home);
export const AccountBoxOutlinedIcon = akarize(Person);
export const BadgeOutlinedIcon = akarize(Person);
export const FolderOutlinedIcon = akarize(Folder);
export const ShieldOutlinedIcon = akarize(Shield);
export const SearchRoundedIcon = akarize(Search);
export const CheckCircleOutlineRoundedIcon = akarize(CircleCheck);
export const MenuRoundedIcon = akarize(ThreeLineHorizontal);
export const NotificationsNoneRoundedIcon = akarize(Bell);
export const LogoutRoundedIcon = akarize(SignOut);
export const GroupOutlinedIcon = akarize(PeopleGroup);
export const GroupsOutlinedIcon = akarize(PeopleMultiple);
export const AccountTreeOutlinedIcon = akarize(Network);
export const AdminPanelSettingsOutlinedIcon = akarize(Shield);
export const WidgetsOutlinedIcon = akarize(Grid);
export const SecurityOutlinedIcon = akarize(Shield);
export const SettingsOutlinedIcon = akarize(Gear);
export const ReceiptLongOutlinedIcon = akarize(Receipt);
export const ExpandMoreRoundedIcon = akarize(ChevronDown);
export const ExpandLessRoundedIcon = akarize(ChevronUp);
export const WarningAmberRoundedIcon = akarize(TriangleAlert);
export const EmailOutlinedIcon = akarize(Envelope);
export const ArrowBackRoundedIcon = akarize(ArrowLeft);
export const KeyboardBackspaceIcon = akarize(ArrowBack);
export const LockOutlinedIcon = akarize(LockOn);
export const CloseRoundedIcon = akarize(Cross);
export const Close = akarize(Cross);
export const DragIndicatorRoundedIcon = akarize(DragVerticalFill);
export const ErrorOutlineRoundedIcon = akarize(CircleAlert);
export const LocalPhoneOutlinedIcon = akarize(Phone);
export const OpenInFullRoundedIcon = akarize(FullScreen);
export const RemoveRoundedIcon = akarize(Minus);
export const RestartAltRoundedIcon = akarize(ArrowCycle);
export const UnfoldLessRoundedIcon = akarize(Reduce);
export const UnfoldMoreRoundedIcon = akarize(Enlarge);
export const WorkOutlineRoundedIcon = akarize(Briefcase);
export const VpnKeyOutlinedIcon = akarize(Key);
export const KeyOutlinedIcon = akarize(Key);
export const FactCheckOutlinedIcon = akarize(Clipboard);
export const CloudUploadOutlinedIcon = akarize(CloudUpload);
export const DownloadOutlinedIcon = akarize(Download);
export const FileOutlinedIcon = akarize(File);
export const CalendarOutlinedIcon = akarize(Calendar);
export const ClockOutlinedIcon = akarize(Clock);
export const CheckIcon = akarize(Check);
export const CheckInIcon = akarize(Check);
export const CheckOutIcon = akarize(SignOut);
